import { ExternalLink } from 'lucide-react'
import { business } from '../../config/business'
import SectionWrapper from '../ui/SectionWrapper'
import Card from '../ui/Card'

function StarRating({ count = 5 }) {
  return (
    <span className="text-accent-400 text-lg tracking-tight select-none" aria-label={`${count} out of 5 stars`}>
      {'★'.repeat(count)}
    </span>
  )
}

export default function Reviews() {
  return (
    <SectionWrapper id="reviews" bg="white">
      <div className="max-w-6xl mx-auto px-4">
        {/* Section header */}
        <div className="text-center mb-14">
          <span className="fade-in-up inline-block text-accent-500 font-semibold text-sm uppercase tracking-widest mb-3">
            What Customers Say
          </span>
          <h2 className="fade-in-up font-heading font-bold text-navy-900 text-4xl md:text-5xl mb-4">
            5.0 ★★★★★
          </h2>
          <p className="fade-in-up text-ink-600 text-lg">
            {business.reviewCount} five-star reviews on Google
          </p>
        </div>

        {/* Review cards */}
        {/* PLACEHOLDER — replace with actual customer reviews in src/config/business.js */}
        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {business.reviews.map((review, i) => (
            <Card key={i} className="fade-in-up p-7">
              <StarRating count={review.rating} />
              <p className="text-ink-600 leading-relaxed mt-4 mb-6 text-[0.95rem]">
                "{review.text}"
              </p>
              <div className="border-t border-surface-100 pt-4">
                <p className="font-semibold text-navy-800 text-sm">{review.name}</p>
                <p className="text-ink-400 text-xs mt-0.5">{review.location}</p>
              </div>
            </Card>
          ))}
        </div>

        {/* Google reviews CTA */}
        <div className="fade-in-up text-center">
          <a
            href={business.googleBusinessUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-surface-50 border border-surface-100 hover:border-accent-500/40 hover:bg-accent-50 text-navy-800 font-semibold px-6 py-3 rounded-xl transition-all duration-200 text-sm"
          >
            Read Our Reviews on Google
            <ExternalLink size={14} />
          </a>
        </div>
      </div>
    </SectionWrapper>
  )
}
